<script>
  import {Router, Route, navigate} from "svelte-routing";
  import {onMount} from "svelte";
  import AdminNavbar from "components/Navbars/AdminNavbar.svelte";
  import Sidebar from "components/Sidebar/Sidebar.svelte";
  import HeaderStats from "components/Headers/HeaderStats.svelte";
  import FooterAdmin from "components/Footers/FooterAdmin.svelte";
  import Settings from "views/admin/Settings.svelte";
  import Users from "../views/admin/Users.svelte";
  import Profile from "../views/Profile.svelte";
  import Groups from "../views/admin/Groups.svelte";
  import {me} from "../services/authService";
  import Subscribers from "../views/admin/Subscribers.svelte";
  import Prints from "../views/admin/Prints.svelte";
  import Jurisdiction from "../views/admin/Jurisdiction.svelte";
  import { loggedUser, settings } from "../stores/settingsStore";
  import { selectedActiveYear } from "../stores/selectedActiveYear";

  export let location;

  onMount(async () => {
    me().then((resp) => {
      if(resp.status === 200 && resp?.data?.email) {
        $loggedUser = resp.data;
        $selectedActiveYear = $settings.subscriptionActiveYear;

        return;
      }

      navigate("/", { replace: true });
    }).catch((err) => {
      if(err?.response?.data?.status === 401){
        navigate("/", { replace: true });
      }
      navigate("/", { replace: true });
    })
  });

</script>

<div>
    <div class="h-screen">
      {#if !!$loggedUser}
          <Sidebar location={location} />
          <FooterAdmin />
          <div class="relative md:ml-64 bg-blueGray-100">
              <AdminNavbar />
              <HeaderStats />
              <div class="px-2 pb-16 md:px-14 mx-auto w-full -mt-32">
                  <Router url="admin">
                  <Route component="{Subscribers}" />
                  <Route path="subscribers/*subscribers" component="{Subscribers}" />
                  <Route path="settings" component="{Settings}" />
                  <Route path="users/*users" component="{Users}" />
                  <Route path="groups/*groups" component="{Groups}" />
                  <Route path="prints/*prints" component="{Prints}" />
                  <Route path="jurisdiction/*jurisdiction" component="{Jurisdiction}" />
                  <Route path="settings/*settings" component="{Settings}" />
                  <Route path="profile" component="{Profile}" />
                </Router>
              </div>
            </div>
      {/if}
    </div>
</div>